var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "zoom_in"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9301_178457",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9301_178457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M12.55 13.5167L8.9 9.86667C8.53333 10.1444 8.13611 10.3528 7.70833 10.4917C7.28056 10.6306 6.83333 10.7 6.36667 10.7C5.15556 10.7 4.125 10.2806 3.275 9.44167C2.425 8.60278 2 7.57778 2 6.36667C2 5.15556 2.425 4.125 3.275 3.275C4.125 2.425 5.15556 2 6.36667 2C7.57778 2 8.60278 2.425 9.44167 3.275C10.2806 4.125 10.7 5.15556 10.7 6.36667C10.7 6.83333 10.6333 7.28056 10.5 7.70833C10.3667 8.13611 10.1556 8.52778 9.86667 8.88333L13.5333 12.5667C13.6667 12.7 13.7306 12.8583 13.725 13.0417C13.7194 13.225 13.65 13.3833 13.5167 13.5167C13.3833 13.65 13.2222 13.7167 13.0333 13.7167C12.8444 13.7167 12.6833 13.65 12.55 13.5167ZM6.36667 9.3C7.17778 9.3 7.86944 9.01389 8.44167 8.44167C9.01389 7.86944 9.3 7.17778 9.3 6.36667C9.3 5.54444 9.01667 4.84444 8.45 4.26667C7.88333 3.68889 7.18889 3.4 6.36667 3.4C5.54444 3.4 4.84444 3.68889 4.26667 4.26667C3.68889 4.84444 3.4 5.54444 3.4 6.36667C3.4 7.18889 3.68889 7.88333 4.26667 8.45C4.84444 9.01667 5.54444 9.3 6.36667 9.3ZM6.35 8.36667C6.16111 8.36667 5.99722 8.29722 5.85833 8.15833C5.71944 8.01944 5.65 7.85556 5.65 7.66667V7.05H5.01667C4.82778 7.05 4.66667 6.98056 4.53333 6.84167C4.4 6.70278 4.33333 6.53889 4.33333 6.35C4.33333 6.16111 4.40278 5.99722 4.54167 5.85833C4.68056 5.71944 4.84444 5.65 5.03333 5.65H5.65V5.01667C5.65 4.82778 5.71944 4.66667 5.85833 4.53333C5.99722 4.4 6.16111 4.33333 6.35 4.33333C6.53889 4.33333 6.70278 4.40278 6.84167 4.54167C6.98056 4.68056 7.05 4.84444 7.05 5.03333V5.65H7.68333C7.87222 5.65 8.03333 5.71944 8.16667 5.85833C8.3 5.99722 8.36667 6.16111 8.36667 6.35C8.36667 6.53889 8.29722 6.70278 8.15833 6.84167C8.01944 6.98056 7.85556 7.05 7.66667 7.05H7.05V7.68333C7.05 7.87222 6.98056 8.03333 6.84167 8.16667C6.70278 8.3 6.53889 8.36667 6.35 8.36667Z",
    fill: "#D3135A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom_in.87611dab1582ad5da9a1e622f3bc7b43.svg";
export { ForwardRef as ReactComponent };